import React from "react";
import {useSelector, useDispatch} from "react-redux";
import useOnClickOutside from "use-onclickoutside";

import * as actionTypes from "../../store/actions/actionTypes";
import Admission_ModalInfo from "../Block/Admission_ModalInfo";
import AdmissionBulkDocumentsPdf from "../AdmissionBulkDocumentsPdf";

/**
 * IMP-804 - Modal that previews the merged bulk admission documents in-browser
 * (with print support) instead of downloading the file to the user's computer.
 * Shown when the hospital toggle manager_bulkDocumentsDownload_useModal is on.
 */
const ModalAdmissionBulkPdf = () => {
    const {show, admission} = useSelector(state => state.modal.admissionBulkPdf);
    const ref = React.useRef(null);
    const dispatch = useDispatch();

    const hideModal = () => dispatch({type: actionTypes.MODAL_ADMISSION_BULK_PDF_HIDE});
    useOnClickOutside(ref, () => hideModal());

    if (!show) return null;

    return (
        <div className={`modal fade ${show ? 'show' : ''}`} id="bulkPdfModal" tabIndex="-1" role="dialog"
             aria-modal="true">
            <div className="modal-dialog modal-wide" role="document" ref={ref} autoFocus={false}>
                <div className="modal-content modal-content-fit">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                            onClick={hideModal}>
                        <span aria-hidden="true">×</span>
                    </button>
                    <div className="modal-body">
                        <h3>Patient Admission Documents for {admission.title} {admission.surname}, {admission.name}</h3>
                        <Admission_ModalInfo admission={admission} showMobileInfo={false}/>
                        <AdmissionBulkDocumentsPdf admissionId={admission.id} width={1000}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalAdmissionBulkPdf;
